import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './home/home.component';
import { UsersComponent } from './users/users.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ProfileComponent } from './profile/profile.component';
import { BusinessComponent } from './business/business.component';
import { CompanyComponent } from './business/company/company.component';
import { FormsComponent } from './forms/forms.component';
import { FormComponent } from './forms/form/form.component'
import { EmployeesComponent } from './employees/employees.component';
import { EmployeeComponent } from './employees/employee/employee.component';
import { SurveyComponent } from './survey/survey.component';
import { SurveyListComponent } from './surveyList/surveyList.component'
import { SurveyEmployeeComponent } from './surveyList/surveyEmployee/surveyEmployee.component'
const routes: Routes = [
  {
  path: '',
  data: {
    title: 'Inicio',
    customLayout: true
  },
  children: [
    {
      path: '',
      component: HomeComponent,
      data: {
        title: 'Inicio',
        customLayout: true
      }
    },{
      path: 'inicio',
      component: DashboardComponent,
      data: {
        title: 'Home',
        customLayout: false
      }
    },{
      path:'usuarios',
      data: {
        title: 'Usuarios',
        customLayout: false
      },
      children:[
        {
          path: '',
          component: UsersComponent,
          data: {
            title: 'Usuarios',
            customLayout: false
          }
        },{
          path: 'nuevo',
          component: ProfileComponent,
          data: {
            title: 'Nuevo usuario',
            customLayout: false
          }
        },{
          path: ':id',
          component: ProfileComponent,
          data: {
            title: 'Detalles del usuario',
            customLayout: false
          }
        }
      ]
    },{
      path:'empresas',
      data: {
        title: 'Empresas',
        customLayout: false
      },
      children:[
        {
          path: '',
          component: BusinessComponent,
          data: {
            title: 'Empresas',
            customLayout: false
          }
        },{
          path: 'nuevo',
          component: CompanyComponent,
          data: {
            title: 'Nueva Empresa',
            customLayout: false
          }
        },{
          path: ':id',
          component: CompanyComponent,
          data: {
            title: 'Detalles de la empresa',
            customLayout: false
          }
        }
      ]
    },{
      path:'formularios',
      data: {
        title: 'Formularios',
        customLayout: false
      },
      children:[
        {
          path: '',
          component: FormsComponent,
          data: {
            title: 'Formularios',
            customLayout: false
          }
        },{
          path: 'nuevo',
          component: FormComponent,
          data: {
            title: 'Nueva Formulario',
            customLayout: false
          }
        },{
          path: ':token',
          component: FormComponent,
          data: {
            title: 'Detalles del formulario',
            customLayout: false
          }
        }
      ]
    },{
      path:'empleados',
      data: {
        title: 'Empleados',
        customLayout: false
      },
      children:[
        {
          path: '',
          component: EmployeesComponent,
          data: {
            title: 'Empleados',
            customLayout: false
          }
        },{
          path: 'nuevo',
          component: EmployeeComponent,
          data: {
            title: 'Nueva empleado',
            customLayout: false
          }
        },{
          path: ':token',
          component: EmployeeComponent,
          data: {
            title: 'Detalles del empleado',
            customLayout: false
          }
        }
      ]
    },{
      path:'encuestas',
      data: {
        title: 'Encuesta',
        customLayout: false
      },
      children:[
        {
          path: '',
          component: SurveyListComponent,
          data: {
            title: 'Encuesta',
            customLayout: false
          }
        },{
          path: ':id',
          component: SurveyEmployeeComponent,
          data: {
            title: 'Detalles de la encuesta',
            customLayout: false
          }
        }
      ]
    }
  ]
  }, {
    path: 'iniciar-sesion',
    loadChildren: './+login/login.module#LoginModule',
    data: {
      title: 'Iniciar sesión en In-Control',
      customLayout: true
    }
  },{
    path: 'encuesta',
    data: {
      title: 'Encuesta',
      customLayout: true
    },
    children: [
      {
        path: '',
        component: SurveyComponent,
        data: {
          title: 'Encuesta',
          customLayout: true
        }
      },
      {
        path: ':form',
        component: SurveyComponent,
        data: {
          title: 'Encuesta',
          customLayout: true
        }
      },
      {
        path: ':form/:user',
        component: SurveyComponent,
        data: {
          title: 'Encuesta',
          customLayout: true
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
